import { useRef, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import useContextStore, { selectCurrentContext, isSwitcherVisible } from '../../store/useContextStore';
import useClickOutside from '../../hooks/useClickOutside';
import { IconChevron } from '../icons';
import { PATHS } from '../../routes/navConfig';

export default function ContextSwitcher() {
  const { contexts, currentContextId, switchContext } = useContextStore();
  const ctx = useContextStore(selectCurrentContext);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();

  useClickOutside(ref, useCallback(() => setOpen(false), []));

  const handleSwitch = (id) => {
    switchContext(id);
    setOpen(false);
    navigate(PATHS.DASHBOARD);
  };

  /* A context can carry a photo (from schoolClassDetails); seeded contexts use
     the design's icon assets; anything else falls back to an emoji mark. */
  const Mark = ({ c, className }) => {
    const src = c.photo || (String(c.mark || '').startsWith('/') ? c.mark : null);
    return src ? (
      <div className={className}><img src={src} alt="" /></div>
    ) : (
      <div className={className}>{c.mark}</div>
    );
  };

  const row = (c) => (
    <div key={c.id} className={`ctx-menu-item ${c.id === currentContextId ? 'on' : ''}`} onClick={() => handleSwitch(c.id)}>
      <Mark c={c} className="mk" />
      <div>
        <div className="tt">{c.name}</div>
        <div className="ss">{c.sub}</div>
      </div>
    </div>
  );

  const masters = contexts.filter((c) => c.type === 'master');
  /* sub groups only — plain classes are hidden here by client request */
  const groups = contexts.filter((c) => c.type === 'class' && isSwitcherVisible(c));

  return (
    <div className="ctx-switcher" ref={ref}>
      <button className={`ctx-btn ${open ? 'open' : ''}`} onClick={() => setOpen(!open)}>
        <Mark c={ctx} className="ctx-btn-mark" />
        <div className="ctx-label">
          <span className="nm">{ctx.name}</span>
          <span className="sb">{ctx.sub}</span>
        </div>
        <IconChevron />
      </button>
      <div className={`ctx-menu ${open ? 'open' : ''}`}>
        {masters.length > 0 && (
          <>
            <div className="ctx-menu-label">{masters.length === 1 ? masters[0].name : 'School Master Pages'}</div>
            {masters.map(row)}
          </>
        )}
        {groups.length > 0 && (
          <>
            <div className="ctx-menu-label">My Sub Groups</div>
            {groups.map(row)}
          </>
        )}
      </div>
    </div>
  );
}
